import { NAV_GROUP_TYPES } from './eventCatalog';
import { actorKeyFor, type LiveSessionEvent } from './types';

export interface EventGroup {
  events: LiveSessionEvent[];
  key: string;
  kind: 'navs' | 'single';
}

const sameRun = (a: LiveSessionEvent, b: LiveSessionEvent) => (
  NAV_GROUP_TYPES.has(a.event_type)
  && a.event_type === b.event_type
  && actorKeyFor(a) === actorKeyFor(b)
);

// Consecutive teacher/student navigation rows from the same actor collapse into one group so a
// 60-slide lesson does not bury the state changes around it. Anything else stays a single row.
export const groupEvents = (events: LiveSessionEvent[]): EventGroup[] => {
  const groups: EventGroup[] = [];

  events.forEach((event) => {
    const last = groups[groups.length - 1];
    if (last && sameRun(last.events[last.events.length - 1], event)) {
      last.events.push(event);
      last.kind = 'navs';
      return;
    }
    groups.push({ events: [event], key: String(event.id), kind: 'single' });
  });

  return groups;
};

export const slideRange = (events: LiveSessionEvent[]): string => {
  const ids = events.map(e => e.metadata.slide_id).filter(id => id != null);
  if (ids.length === 0) return '';
  const first = ids[0];
  const last = ids[ids.length - 1];
  return first === last ? `slide ${first}` : `slide ${first} → ${last}`;
};
